import { motion } from "framer-motion"

const GP = "{GP}"
const AnimateLoader = () => {
    return (

        <motion.div
            className="loading"
            initial={{ x: '-100%', y: '-100%' }}
            animate={{ x: 0, y: 0 }}
            exit={{ y: '150%' }}
        >
            <div className="loader">
                <span>{GP}</span>
            </div>
        </motion.div>

    )

}

export default AnimateLoader;